import SignIn from '@/views/auth/SignIn'
import SignUp from '@/views/auth/SignUp'
import ForgotPassword from '@/views/auth/ForgotPassword'
import ResetPassword from '@/views/auth/ResetPassword'
import ComfirmEmail from '@/views/auth/ComfirmEmail'
import Staffs from '@/views/staff/Staffs'
import Slots from '@/views/slot/Slots'
import Staff1 from '@/views/staff/Staff1'
import Contacts from '@/views/contact/Contacts'
import ContactImporter from '@/views/contact/ContactImporter'
// ---------------- TEACHER -------------------------------
import Teachers from '@/views/teacher/Teachers'
import TeacherDashboard from '@/views/teacher/Dashboard'
import TeacherAttendance from '@/views/teacher/Attendances'
import TeacherClasses from '@/views/teacher/Classes'
import Teacher from '@/views/teacher/Teacher'
// ---------------- CLASSES -------------------------------
import Classes from '@/views/class/Classes'

import ClassDetail from '@/views/class/ClassDetail'
import Courses from '@/views/course/Courses'
import Course from '@/views/course/Course'
import CalendarPage from '@/views/calendar/CalendarPage'
import Products from '@/views/department/Products'
import Attendances from '@/views/attendance/Attendances'
import ClassAttendances from '@/views/class/ClassAttendances'
import ClassStudents from '@/views/class/ClassStudents'
import ClassMark from '@/views/class/ClassMark'
import FinalScoreGrading from '@/modules/class/marks/FinalScoreGrading.vue'
import RetestMarkSheet from '@/modules/class/marks/RetestMarkSheet.vue'
import ClassSlots from '@/views/class/ClassSlots'

import Generations from '@/views/generation/Generations'
// ---------------- MAJOR & COURSE -------------------------------
import MajorConfig from '@/views/major/MajorConfig'
import Major from '@/views/major/Major'
// ---------------- STUDENT -------------------------------
import Students from '@/views/student/Students'
import Reservation from '@/views/student/Reservation.vue'
import StudentDashboard from '@/views/student/Dashboard'
import Student from '@/views/student/Student'
import StudentClasses from '@/views/student/Classes'
import StudentMajors from '@/views/student/Major.vue'
import StudentImporter from '@/views/student/StudentImporter.vue'
// ---------------- SALE -------------------------------
import Sales from '@/views/sale/Sale.vue'
import Bill from '@/views/accounting/Bills'
import Leads from '@/views/lead/Leads.vue'
import Tuition from '@/views/sale/Tuition'
// ---------------- DEPARTMENT -------------------------------
import Department from '@/views/department/Department'
import DashBoard from '@/views/dashboard/Dashboard.vue'
import Rooms from '@/views/room/Rooms'
import Showcases from '@/views/showcase/ShowcaseMajor.vue'
import ShowcaseSlider from '@/views/showcase/ShowcaseSlider.vue'
// ---------------- FACILITY -------------------------------
import Facilities from '@/views/facility/Facilities'
import Facility from '@/views/facility/Facility'
import Books from '@/views/book/Books'
import Book from '@/views/book/Book'
// ---------------- LEARNING -----------------------------
import Schedule from '@/views/schedule/Schedule.vue'
// ---------------- LAYOUT -------------------------------
import GuestLayout from '../components/layout/GuestLayout'
import MainLayout from '../components/layout/MainLayout'
import Page404 from '@/views/Page404'
import MarkSheet from '@/views/report/mark-sheet/MarkSheet.vue'
import MarkSheetDetail from '@/views/report/mark-sheet-detail/MarkSheetDetail.vue'
import MarkSheetContent from '../views/report/mark-sheet-detail/MarkSheetContent.vue'
import MarkSheetConfig from '../views/report/mark-sheet-detail/MarkSheetConfig.vue'
import AccountSheet from '../views/report/account-sheet/AccountSheet.vue'
import AccountSheetDetail from '../views/report/account-sheet-detail/AccountSheetDetail.vue'
import AccountSheetList from '../views/report/account-sheet-list/AccountSheetList.vue'
import ListManagers from '../views/managers/ListManagers.vue'
import EditManager from '../views/managers/EditManager.vue'
import ReservedStudents from '../views/student/ReservedStudents.vue'
import AbortedStudents from '../views/student/AbortedStudents.vue'
import GraduatedStudents from '../views/student/GraduatedStudents.vue'
const routes = [
  {
    path: '/',
    component: GuestLayout,
    children: [
      {
        path: 'signin',
        name: 'signIn',
        component: SignIn,
        meta: {
          title: 'Sign In',
          auth: false
        }
      },
      {
        path: 'signup',
        name: 'signUp',
        component: SignUp,
        meta: {
          title: 'Sign Up',
          auth: false
        }
      },
      {
        path: '/forgot-password',
        name: 'forgotPassword',
        component: ForgotPassword,
        meta: {
          title: 'Quên mật khẩu',
          auth: false
        }
      },
      {
        path: '/confirm-email',
        name: 'confirmEmail',
        component: ComfirmEmail,
        meta: {
          title: 'Xác nhận email',
          auth: false
        }
      },
      {
        path: '/reset-password',
        name: 'resetPassword',
        component: ResetPassword,
        meta: {
          title: 'Tạo lại mật khẩu',
          auth: false
        }
      }
    ]
  },
  {
    path: '/',
    component: MainLayout,
    meta: {
      title: 'Trang chủ'
    },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: DashBoard,
        meta: {
          title: 'Dashboard',
          auth: true
        }
      },
      {
        path: 'schedule',
        name: 'schedule',
        component: Schedule,
        meta: {
          title: 'Thời Khóa Biểu',
          auth: true
        }
      },
      {
        path: 'bill',
        name: 'bill',
        component: Bill,
        meta: {
          title: 'Doanh Thu',
          auth: true
        }
      },
      {
        path: 'facilities',
        name: 'facilities',
        component: Facilities,
        meta: {
          title: 'Cơ Sở Vật CHất',
          auth: true
        }
      },
      {
        path: 'facility/:id',
        component: Facility,
        name: 'facility',
        meta: {
          title: 'Cơ sở vật chất',
          auth: true
        }
      },
      {
        path: 'books',
        name: 'books',
        component: Books,
        meta: {
          title: 'Quản Lý Thư Viện',
          auth: true
        }
      },
      {
        path: 'book/:id',
        component: Book,
        name: 'book',
        meta: {
          title: 'Quản Lý Sách',
          auth: true
        }
      },
      {
        path: 'calendar',
        component: CalendarPage,
        name: 'calendar',
        meta: {
          title: 'Calendar',
          auth: true
        }
      },
      {
        path: 'contact-importer',
        name: 'Contact Importer',
        component: ContactImporter,
        meta: {
          title: 'Import Contacts',
          auth: true
        }
      },
      {
        path: 'contacts',
        component: Contacts,
        name: 'contacts',
        meta: {
          title: 'Học viên Tiềm Năng',
          auth: true
        }
      },
      {
        path: 'attendances',
        component: Attendances,
        name: 'attendances',
        meta: {
          title: 'Chấm Công',
          auth: true
        }
      },
      {
        path: 'customers',
        component: Contacts,
        name: 'customers',
        meta: {
          title: 'Học viên Hàng Hiện Tại',
          auth: true
        }
      },
      {
        path: 'majors',
        component: Major,
        name: 'majors',
        meta: {
          title: 'Chuyên Ngành',
          auth: true
        }
      },
      {
        path: 'generations',
        component: Generations,
        name: 'Generations',
        meta: {
          title: 'Niên khóa',
          auth: true
        }
      },
      {
        path: 'rooms',
        component: Rooms,
        name: 'Rooms',
        meta: {
          title: 'Phòng Học',
          auth: true
        }
      },
      {
        path: 'showcases',
        component: Showcases,
        name: 'Showcases',
        meta: {
          title: 'Sản phẩm học sinh',
          auth: true
        }
      },
      {
        path: 'showcase-slider',
        component: ShowcaseSlider,
        name: 'ShowcaseSlider',
        meta: {
          title: 'Slider trang sản phẩm',
          auth: true
        }
      },
      {
        path: 'major/:id',
        component: MajorConfig,
        name: 'major',
        meta: {
          title: 'Cấu Hình Chuyên Ngành',
          auth: true
        }
      },
      {
        path: 'products',
        component: Products,
        name: 'Products',
        meta: {
          title: 'Sản Phẩm - Combo',
          auth: true
        }
      },
      {
        path: 'staffs',
        name: 'staffs',
        component: Staffs,
        props: { role: 'staffs' },
        meta: {
          title: 'Nhân Viên',
          auth: true
        }
      },
      {
        path: 'slots',
        name: 'slots',
        component: Slots,
        props: { role: 'slots' },
        meta: {
          title: 'Tất cả các buổi học',
          auth: true
        }
      },
      {
        path: 'staff/:id',
        name: 'staff',
        component: Staff1,
        meta: {
          title: 'Nhân Viên',
          auth: true
        }
      },
      {
        path: 'teachers',
        name: 'teachers',
        component: Teachers,
        props: { role: 'teacher' },
        meta: {
          title: 'Giáo Viên',
          auth: true
        }
      },
      {
        path: 'managers',
        name: 'managers',
        component: ListManagers,
        meta: {
          title: 'Quản lý',
          auth: true
        }
      },
      {
        path: 'teacher-dashboard',
        name: 'TeacherDashboard',
        component: TeacherDashboard,
        meta: {
          title: 'Dashboard',
          auth: true
        }
      },
      {
        path: '/teacher-classes',
        name: 'TeacherClasses',
        component: TeacherClasses,
        meta: {
          title: 'Danh Sách Lớp Của Tôi',
          auth: true
        }
      },
      {
        path: '/teacher-attendance',
        name: 'TeacherAttendance',
        component: TeacherAttendance,
        meta: {
          title: 'Điểm Danh Của Tôi',
          auth: true
        }
      },
      {
        path: 'leads',
        name: 'leads',
        component: Leads,
        meta: {
          title: 'Quản lý Doanh',
          auth: true
        }
      },
      {
        path: 'teacher/:id',
        name: 'teacher',
        component: Teacher,
        meta: {
          title: 'Teacher',
          auth: true
        }
      },
      {
        path: 'manager/accountant/:id',
        name: 'accountant',
        component: EditManager,
        meta: {
          title: 'Kế toán',
          auth: true
        }
      },
      {
        path: 'manager/education-manager/:id',
        name: 'accountant',
        component: EditManager,
        meta: {
          title: 'Quản lý đào tạo',
          auth: true
        }
      },
      {
        path: 'manager/super-admin/:id',
        name: 'super-admin',
        component: EditManager,
        meta: {
          title: 'Quản lý cao cấp',
          auth: true
        }
      },
      {
        path: 'manager/staff/:id',
        name: 'staff',
        component: EditManager,
        meta: {
          title: 'Quản lý',
          auth: true
        }
      },
      {
        path: 'student-dashboard',
        name: 'StudentDashboard',
        component: StudentDashboard,
        meta: {
          title: 'Dashboard',
          auth: true
        }
      },
      {
        path: 'student-majors',
        name: 'StudentMajor',
        component: StudentMajors,
        meta: {
          title: 'Lộ Trình Của Tôi',
          auth: true
        }
      },
      {
        path: 'student-classes',
        name: 'StudentClasses',
        component: StudentClasses,
        meta: {
          title: 'Lớp Của Tôi',
          auth: true
        }
      },
      {
        path: 'students',
        name: 'students',
        component: Students,
        props: { role: 'student' },
        meta: {
          title: 'Students',
          auth: true
        }
      },
      {
        path: 'reserved-students',
        name: 'reserved-students',
        component: ReservedStudents,
        meta: {
          title: 'Reserved Students',
          auth: true
        }
      },
      {
        path: 'abortions',
        name: 'abortions',
        component: AbortedStudents,
        meta: {
          title: 'Thôi học',
          auth: true
        }
      },
      {
        path: 'graduations',
        name: 'graduations',
        component: GraduatedStudents,
        meta: {
          title: 'Tốt nghiệp',
          auth: true
        }
      },
      {
        path: 'reservation',
        name: 'Reservation',
        component: Reservation,
        props: { role: 'student' },
        meta: {
          title: 'Quản lý bảo lưu',
          auth: true
        }
      },
      {
        path: 'student/:id',
        name: 'studentInfor',
        component: Student,
        props: { role: 'student' },
        meta: {
          title: 'Student',
          auth: true
        }
      },
      {
        path: 'student-import',
        name: 'studentImport',
        component: StudentImporter,
        props: { role: 'student' },
        meta: {
          title: 'Student Importer',
          auth: true
        }
      },
      {
        path: 'courses',
        name: 'courses',
        component: Courses,
        meta: {
          auth: true,
          title: 'Course List'
        }
      },
      {
        path: 'course/:id',
        name: 'courseInfo',
        component: Course,
        meta: {
          auth: true,
          title: 'Course Info'
        }
      },
      {
        path: 'classes',
        name: 'classes',
        component: Classes,
        meta: {
          title: 'Lớp học',
          auth: true
        }
      },
      {
        path: 'class/:id',
        name: 'class',
        component: ClassDetail,
        meta: {
          title: 'Lớp học',
          auth: true
        }
      },
      {
        path: 'class/attendances/:id',
        name: 'class',
        component: ClassAttendances,
        meta: {
          title: 'Điểm danh',
          auth: true
        }
      },
      {
        path: 'class/students/:id',
        name: 'class-student',
        component: ClassStudents,
        meta: {
          title: 'Học viên',
          auth: true
        }
      },
      {
        path: 'class/mark/:id',
        name: 'class-mark',
        component: ClassMark,
        meta: {
          title: 'Điểm số',
          auth: true
        }
      },
      {
        path: 'class/:id/mark-sheets',
        name: 'class-mark-sheets',
        component: FinalScoreGrading,
        meta: {
          title: 'Phiếu điểm',
          auth: true
        }
      },
      {
        path: 'class/:id/retest-mark-sheet',
        name: 'retest-mark-sheet',
        component: RetestMarkSheet,
        meta: {
          title: 'Phiếu điểm thi lại',
          auth: true
        }
      },
      {
        path: 'class/schedule/:id',
        name: 'class-slot',
        component: ClassSlots,
        meta: {
          title: 'Điểm danh',
          auth: true
        }
      },
      {
        path: 'category/list',
        name: 'category',
        component: Classes,
        meta: {
          title: 'Categories List',
          auth: true
        }
      },
      {
        path: 'department/:id',
        name: 'Department',
        component: Department,
        meta: {
          title: 'Department',
          auth: true
        }
      },
      {
        path: 'sales',
        name: 'Sales',
        component: Sales,
        meta: {
          title: 'Bán Hàng',
          auth: true
        }
      },
      {
        path: 'liability',
        name: 'Tuition',
        component: Tuition,
        meta: {
          title: 'Đóng học phí',
          auth: true
        }
      },
      {
        path: '/mark-sheets',
        name: 'Marksheet',
        component: MarkSheet,
        meta: {
          title: 'Bảng điểm tổng kết',
          auth: true
        }
      },
      {
        path: '/mark-sheets/:id',
        name: 'Marksheet detail',
        component: MarkSheetDetail,
        redirect: { name: 'Marksheet detail content' },
        children: [
          { path: 'config', component: MarkSheetConfig, name: 'Marksheet detail config' },
          { path: 'content', component: MarkSheetContent, name: 'Marksheet detail content' }
        ],
        meta: {
          auth: true
        }
      },
      {
        path: '/account-sheets',
        component: AccountSheet,
        redirect: { name: 'Account sheets' },
        meta: {
          auth: true,
          title: 'Giảng phí'
        },
        children: [
          { path: ':id', component: AccountSheetDetail, name: 'Marksheet detail content' },
          {
            path: '',
            component: AccountSheetList,
            name: 'Account sheets'
          }
        ]
      },

      {
        path: '*',
        name: 'page404',
        component: Page404,
        meta: {
          title: 'Page not found'
        }
      }
    ]
  }
]

export default routes
